import { Component, Input, OnChanges, OnInit, SimpleChanges, ElementRef } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LinkButtonComponent } from '../common/components/general/link-button/link-button.component';
import { FooterService } from './footer.service';

import { FooterData, FooterModel } from './footer.model';
import { COMPONENT_META_DATA } from '../common/constants/component-meta-data';

import { ContentModel } from '../common/models/content.model';
import { eLinkButtonTarget } from '../common/components/general/link-button/link-button.model';
import { ContentFilterPipe } from '../common/pipes/content-filter.pipe';
import { ElementsService } from '../common/services/elements.service';
import { GtmService } from '../common/services/gtm/gtm.service';
import { GtmEvent } from '../common/models/gtm-event.model';
import { environment } from '../../environments/environment';
import { isLPMIHost } from '../common/util/utils';

@Component({
  selector: 'nuc-footer',
  imports: [MatToolbarModule, LinkButtonComponent, ContentFilterPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit, OnChanges {
  @Input() customThemeClass: string;
  displayClass: string = "blueTheme";
  @Input() pagePath: string;

  constructor(private footerService: FooterService, private elementRef: ElementRef, private elementsService: ElementsService, private gtm: GtmService) { }
  footerComponentLinks: FooterModel[] = [];
  componentType: string = COMPONENT_META_DATA.FOOTER.VALUE;
  pageContent: ContentModel[];
  eLinkButtonTarget = eLinkButtonTarget;
  LABELS = COMPONENT_META_DATA.FOOTER.LABELS;
  pagePathFromOrigin: string;
  footerCqPath?: string;

  get copyRightAueResource(): string | null {
    const copyRightLabel = this.pageContent?.find((item) => item.labelId === this.LABELS.COPYRIGHT_TEXT);
    const cqPath = copyRightLabel?.cqPath;
    if (!cqPath) {
      return null;
    }
    return `urn:aemconnection:${cqPath}`;
  }

  ngOnInit() {
    this.elementsService.setAngularContext(this.elementRef);
    this.initializePage();
  }

  private initializePage() {
    if(isLPMIHost(window.location.hostname, environment.LPMI_URL)){
      this.displayClass = "landingBlackTheme";
    }
    this.footerService.getFooter().subscribe((data: FooterData) => {
      this.pageContent = data.labels;
      this.footerComponentLinks = data.links;
      this.footerCqPath = data.cqPath;
    });
  }

  onClick(item: FooterModel, event?: Event) {
    const gtmEvent = GtmEvent.create("FOOTER", 'Footer', 'Redirection::External', item.name);
    this.gtm.pushEvent(gtmEvent);

    if (item.category == "cookie-policy") {
      let cookieTrigger = document.getElementById("cookieTrigger");
      if (cookieTrigger) {
        event.preventDefault();
        cookieTrigger.click();
      }
    }
    else {
    // if (item.category != "cookie-policy") {
      fetch(item.link).then(res => res.blob()).then((blob: Blob) => {
        item.link = URL.createObjectURL(blob);
        window.open(item.link, '_blank');
      }).catch(err => console.log("error"));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.pagePathFromOrigin = window.location.href;
    if(isLPMIHost(window.location.hostname, environment.LPMI_URL)){
      this.displayClass = "landingBlackTheme";
    }
    else{
      this.displayClass = this.pagePathFromOrigin.endsWith("landing") ? "landingWhiteTheme" : this.customThemeClass || "blueTheme";
    }
  }

}
